import "@fontsource/oswald/400.css";
import "@fontsource/oswald/500.css";
import "@fontsource/oswald/600.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WebStorageStateStore } from "oidc-client-ts";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { App } from "./App";

async function bootstrap() {
  const res = await fetch("/api/config");
  if (!res.ok) {
    document.getElementById("root")!.innerHTML =
      "<pre style='padding:24px;font-family:monospace;color:#c33'>Falha ao carregar /api/config</pre>";
    return;
  }
  const cfg = (await res.json()) as {
    oidc: {
      authority: string;
      client_id: string;
      redirect_uri: string;
      post_logout_redirect_uri: string;
      scope: string;
    };
  };

  const oidcConfig = {
    authority: cfg.oidc.authority,
    client_id: cfg.oidc.client_id,
    redirect_uri: cfg.oidc.redirect_uri,
    post_logout_redirect_uri: cfg.oidc.post_logout_redirect_uri,
    scope: cfg.oidc.scope,
    response_type: "code",
    // A tela do Cognito abre em ingles por padrao. `lang` e a unica forma de
    // traduzir — o editor de branding nao mexe em texto, e a localizacao so
    // existe no managed login. Vai em toda requisicao de propósito: o Cognito
    // guarda a preferencia em cookie, mas janela anonima e aparelho novo
    // comecam sem ele.
    extraQueryParams: { lang: "pt-BR" },
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    loadUserInfo: false,
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { retry: 0, refetchOnWindowFocus: false },
    },
  });

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider {...oidcConfig}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </AuthProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
}

bootstrap();
